import base from '../base/base';
import header from '../base/header';

import TopVideoPlayer from '../../components/platformPlayer/TopVideoPlayer';

new TopVideoPlayer();



// WEBPACK FOOTER //
// ./assets/layouts/section-front/section-front.js